import gql from "graphql-tag";

/** Logged-in only — includes reviewer display names. */
export default gql`
  query getSellerReviewsWithBuyers($sellerId: Int!) {
    allSellerReviews(condition: { sellerId: $sellerId }) {
      nodes {
        id
        sellerId
        buyerId
        listingId
        rating
        reviewText
        transactionCompleted
        createdAt
        buyer: userByBuyerId {
          id
          firstname
          lastname
        }
        listing: carsForSaleByListingId {
          id
          year
          make
          model
          trim
        }
      }
    }
  }
`;
